import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

const UserActivity = () => {
  const [messageCounts, setMessageCounts] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'count', direction: 'desc' });
  const [activeUserCountWeek, setActiveUserCountWeek] = useState(0);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const token = localStorage.getItem('userToken');

    const fetchMessageCounts = async () => {
      try {
        const response = await fetch('/user-message-counts', { headers: { Authorization: `Bearer ${token}` } });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setMessageCounts(data);
      } catch (error) {
        console.error('Failed to fetch message counts:', error);
      }
    };

    const fetchActiveUsersWeek = async () => {
      try {
        const response = await fetch('/active-users-last-week', { headers: { Authorization: `Bearer ${token}` } });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setActiveUserCountWeek(data.activeUserCountWeek || 0);
      } catch (error) {
        setActiveUserCountWeek(0);
      }
    };

    fetchMessageCounts();
    fetchActiveUsersWeek();
  }, []);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedMessageCounts = [...messageCounts].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div>
      <div style={{
        background: "#f2f9ff",
        color: "#150065",
        border: "1px solid #e5e8fa",
        borderRadius: 10,
        padding: "16px 28px",
        margin: "16px 0",
        fontWeight: 500,
        fontSize: "1.2em",
        width: "fit-content"
      }}>
        {t("active_users_last_7d")} <span style={{ fontWeight: "bold", color: "#0a9c72" }}>{activeUserCountWeek}</span>
      </div>
      <table className="user-activity-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('email')}>
              {t("user")} {sortConfig.key === 'email' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('domain')}>
              {t("domain")} {sortConfig.key === 'domain' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('count')} className='right-align'>
              {t("messages")} {sortConfig.key === 'count' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
            </th>
            <th onClick={() => handleSort('lastMessageTime')}>
              {t("last_used")} {sortConfig.key === 'lastMessageTime' && (sortConfig.direction === 'asc' ? '▲' : '▼')}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedMessageCounts.map((user) => (
            <tr key={user._id}>
              <td>{user.email}</td>
              <td>{user.domain}</td>
              <td className="right-align">{user.count}</td>
              <td>{formatDate(user.lastMessageTime)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserActivity;